export enum UserConfigurationModalTab {
  Access = 'access',
}
